import { useEffect, useState } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import PageContentWrapper from "../../components/PageContentWrapper";
import { Button, Input, Space, Table } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { getAffiliates } from "../../appRedux/actions/Affiliates";

export default function AffiliatesPage() {
  const { search } = useLocation();
  const history = useHistory();
  const params = new URLSearchParams(search);
  const searchValue = params.get('search') || null;
  const orderBy = params.get('order_by') || 'affiliate_point';
  const orderType = params.get('order_type') || 'desc';
  const page = parseInt(params.get('current_page')) || 1;
  const pageSize = parseInt(params.get('page_size')) || 10;

  const [affiliates, setAffiliates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalAffiliates, setTotalAffiliates] = useState(0);

  const [inputValue, setInputValue] = useState(searchValue);

  useEffect(() => {
    setInputValue(searchValue);
  }, [searchValue]);

  const onSearch = (filter) => {
    const params = new URLSearchParams(search);
    Object.keys(filter).forEach((key) => {
      if (filter[key] !== null && filter[key] !== undefined && filter[key] !== "") {
        params.set(key, filter[key]);
      } else {
        params.delete(key);
      }
    });
    if (filter.search !== undefined) {
      params.delete('current_page');
    }
    history.push({
      search: params.toString(),
    });
  };

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (inputValue !== searchValue) {
        onSearch({ search: inputValue });
      }
    }, 500);
    return () => clearTimeout(timeoutId);
  }, [inputValue, searchValue]);

  useEffect(() => {
    setLoading(true);
    getAffiliates({
      search: searchValue,
      order_by: orderBy,
      order_type: orderType,
      current_page: page,
      page_size: pageSize,
    })
      .then((res) => {
        setAffiliates(res.data);
        setTotalAffiliates(res.meta.total);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }, [searchValue, orderBy, orderType, page, pageSize]);

  const handleTableChange = (pagination, filters, sorter, extra) => {
    const params = new URLSearchParams(search);

    if (extra.action === 'paginate') {
      params.set('current_page', pagination.current);
      params.set('page_size', pagination.pageSize);
    }

    if (extra.action === 'sort') {
      if (sorter.field) {
        params.set('order_by', sorter.field);
        params.set('order_type', sorter.order === 'descend' ? 'desc' : 'asc');
      } else {
        params.delete('order_by');
        params.delete('order_type');
      }
      // Optional: Reset to page 1 when sorting changes
      params.set('current_page', 1);
    }
    
    history.push({ search: params.toString() });
  };

  const handleReset = () => {
    setInputValue("");
    history.push({
      search: "",
    });
  };

  const columns = [
    {
      title: "Nama / Nama Panggilan",
      dataIndex: "name",
      sorter: true,
      sortOrder: orderBy === "name" ? (orderType === "asc" ? "ascend" : "descend") : null,
      render: (text, record) => (
        <div>
          {text} {record.nickname ? `(${record.nickname})` : ""}
        </div>
      ),
    },
    {
      title: "Email",
      dataIndex: "email",
      sorter: true,
      sortOrder: orderBy === "email" ? (orderType === "asc" ? "ascend" : "descend") : null,
    },
    {
      title: "Nomor WhatsApp",
      dataIndex: "whatsapp_number",
      sorter: true,
      sortOrder: orderBy === "whatsapp_number" ? (orderType === "asc" ? "ascend" : "descend") : null,
    },
    {
      title: "Perusahaan",
      dataIndex: "company",
      sorter: true,
      sortOrder: orderBy === "company" ? (orderType === "asc" ? "ascend" : "descend") : null,
    },
    {
      title: "Posisi Pekerjaan",
      dataIndex: "job_position",
      sorter: true,
      sortOrder: orderBy === "job_position" ? (orderType === "asc" ? "ascend" : "descend") : null,
    },
    {
      title: "Alamat",
      dataIndex: "address",
      sorter: true,
      sortOrder: orderBy === "address" ? (orderType === "asc" ? "ascend" : "descend") : null,
    },
    {
      title: "Kode Afiliasi",
      dataIndex: "affiliate_code",
      sorter: true,
      sortOrder: orderBy === "affiliate_code" ? (orderType === "asc" ? "ascend" : "descend") : null,
    },
    {
      title: "Provinsi",
      dataIndex: "province",
      sorter: true,
      sortOrder: orderBy === "province" ? (orderType === "asc" ? "ascend" : "descend") : null,
    },
    {
      title: "Poin Afiliasi",
      dataIndex: "affiliate_point",
      sorter: true,
      sortOrder: orderBy === "affiliate_point" ? (orderType === "asc" ? "ascend" : "descend") : null,
    },
  ];

  return (
    <PageContentWrapper
      title="Affiliates Monitoring"
    >
      <Space direction="vertical" style={{ width: "100%" }}>
        <Space wrap>
          <Input
            style={{ margin: 0 }}
            placeholder="ketik pencarian"
            allowClear
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
          />
          <Button
            type="primary"
            style={{ margin: 0 }}
            disabled={
              inputValue === ""
            }
            onClick={handleReset}
          >
            Reset
          </Button>
        </Space>
        <Table
          dataSource={affiliates}
          columns={columns}
          loading={loading}
          rowKey="id"
          pagination={{
            current: page,
            pageSize: pageSize,
            total: totalAffiliates,
            showSizeChanger: true,
            showTotal: (total) => `Total ${total} data`,
          }}
          onChange={handleTableChange}
        />
      </Space>
    </PageContentWrapper>
  );
};